export default __webpack_public_path__ + "static/studio-slider-18-f5dc2d24418f630ff39de31bad095d98.png";